import { z } from "zod";

import {
  billingMethodSchema,
  contractTypeSchema,
  customerSchema,
  userSchema,
} from "../commons";

export const createBodySchema = z.object({
  gigID: z.string().nonempty(),
  description: z.string().nonempty(),
  reportWeek: z.coerce.number().min(1).max(53),
  reportYear: z.coerce.number().min(2022),
  hoursSpent: z.coerce.number().optional(),
  billingMethod: billingMethodSchema,
  contractType: contractTypeSchema.optional(),
  images: z
    .array(
      z.object({
        source: z.string().nonempty(),
        tags: z.array(z.string()).nonempty(),
      }),
    )
    .optional(),
});

export type CreateBody = z.infer<typeof createBodySchema>;

export const createRequestSchema = z.object({
  body: createBodySchema,
});

export type CreateRequest = z.infer<typeof createRequestSchema>;

export const createResponseSchema = z.object({
  token: z.string(),
});

export type CreateResponse = z.infer<typeof createResponseSchema>;

export const verifyTokenQuerySchema = z.object({
  t: z.string().nonempty(),
});

export type VerifyTokenQuery = z.infer<typeof verifyTokenQuerySchema>;

export const verifyTokenRequestSchema = z.object({
  query: verifyTokenQuerySchema,
});

export type VerifyTokenRequest = z.infer<typeof verifyTokenRequestSchema>;

export const verifyTokenResponseSchema = z.object({
  client: userSchema.partial(),
  talentRate: z.number(),
  customer: customerSchema,
  hoursSpent: z.number(),
  totalReports: z.number(),
  billingMethod: billingMethodSchema,
  contractType: contractTypeSchema,
  payoutAmount: z.number(),
  isOnboarded: z.boolean(),
  reportWeeks: z.number().optional(),
  currentWeek: z.number().optional(),
});

export type VerifyTokenResponse = z.infer<typeof verifyTokenResponseSchema>;
